<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted () {
    const options = {
      animation: {
        animateRotate: true
      },
      legend: {
        position: 'top',
        fullWidth: false
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      }
    }
    this.renderChart(this.data, options)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/reports/doughnut.vue